import type { AgentToolListParams, AgentToolParams, CreateToolRequest } from '../agent.api.types';
import type { Tool } from '../agent.types';
import {
  transformCreateToolRequest,
  transformCreateToolResponse,
  transformListToolsResponse,
  transformUpdateToolRequest,
} from '../transformers';
import { type Builder } from './types';

export const toolsEndpoints = (builder: Builder) => ({
  listAgentTools: builder.query<Tool[], AgentToolListParams>({
    query: ({ agentId, projectId }) => ({
      url: `agents/${agentId}/tools`,
      headers: {
        'Project-Id': projectId,
      },
    }),
    transformResponse: transformListToolsResponse,
    providesTags: ['Tools'],
  }),
  createAgentTool: builder.mutation<Tool, { agentId: string; request: CreateToolRequest; projectId: string }>({
    query: ({ agentId, request, projectId }) => ({
      url: `agents/${agentId}/tools`,
      method: 'POST',
      body: transformCreateToolRequest(request),
      headers: {
        'Project-Id': projectId,
      },
    }),
    transformResponse: transformCreateToolResponse,
    invalidatesTags: ['Tools'],
  }),
  getAgentTool: builder.query<Tool, AgentToolParams>({
    query: ({ agentId, toolId, projectId }) => ({
      url: `agents/${agentId}/tools/${toolId}`,
      headers: {
        'Project-Id': projectId,
      },
    }),
    transformResponse: transformCreateToolResponse,
  }),
  updateAgentTool: builder.mutation<Tool, AgentToolParams & { request: Partial<Tool> }>({
    query: ({ agentId, toolId, request, projectId }) => ({
      url: `agents/${agentId}/tools/${toolId}`,
      method: 'PATCH',
      body: transformUpdateToolRequest(request),
      headers: {
        'Project-Id': projectId,
      },
    }),
    invalidatesTags: ['Tools'],
  }),
  deleteAgentTool: builder.mutation<void, AgentToolParams>({
    query: ({ agentId, toolId, projectId }) => ({
      url: `agents/${agentId}/tools/${toolId}`,
      method: 'DELETE',
      headers: {
        'Project-Id': projectId,
      },
    }),
    invalidatesTags: ['Tools'],
  }),
});
